import { Gym, TimeSlotEligibility, TimeSlotType } from 'fitbeat.models';

import { UserProfile } from '../entities/user/userprofile';

export class UserTimeSlotTypeEligibility {
  private eligibleTimeSlots: TimeSlotType[];
  private ineligibleReasonForOtherSlots: TimeSlotEligibility;

  constructor(user: UserProfile, gym: Gym) {
    if (UserProfile.hasNeverCheckedIn(user) && !gym.enableStudioAppCheckIn) {
      this.eligibleTimeSlots = [TimeSlotType.Peak];
      this.ineligibleReasonForOtherSlots = TimeSlotEligibility.NotAllowedFirstSessionMustBePeak;
    } else {
      this.eligibleTimeSlots = getTimeSlotTypesBasedOnPlan(user);
      this.ineligibleReasonForOtherSlots = gym.allowUpdatingSubscriptionInSelfManagementPortal
        ? TimeSlotEligibility.SubscriptionUpgradeRequired
        : TimeSlotEligibility.NotAllowedByPaymentPlan;
    }
  }

  public isEligibleFor(timeSlotType: TimeSlotType) {
    return this.checkEligibilityFor(timeSlotType) === TimeSlotEligibility.Eligible;
  }

  public checkEligibilityFor(timeSlotType: TimeSlotType): TimeSlotEligibility {
    if (this.eligibleTimeSlots.indexOf(timeSlotType) === -1) {
      return this.ineligibleReasonForOtherSlots;
    }
    return TimeSlotEligibility.Eligible;
  }
}

function getTimeSlotTypesBasedOnPlan(user: UserProfile) {
  const anyTimeSlots = [TimeSlotType.Peak, TimeSlotType.OffPeak, TimeSlotType.AnyTime];
  if (user.has24HourAccess) {
    return anyTimeSlots;
  }
  switch (user.timeSlotType) {
    case TimeSlotType.Peak:
      return [TimeSlotType.Peak];
    case TimeSlotType.OffPeak:
      return [TimeSlotType.OffPeak];
    case TimeSlotType.None:
      return [];
    default:
      return anyTimeSlots;
  }
}
